<div class="auth-container sign-up-container">

  <div>
    <h1 class="primary-font-semibold heading">{{ 'authentication.sign_up' | translate }}</h1>
    <app-error-messages [control]="signupForm" [forKeys]="['serverValidation']"
      [errorKeyMapping]="fieldValidationRules().signupForm" class="primary-font-medium form-description" />
  </div>
  <app-social-login-buttons [autoRedirectOnSocialLogin]="autoRedirectOnSocialLogin()"
    [postAuthRedirect]="postAuthRedirect()" [theme]="theme()" />

  <div class="or-container flex-center">
    <div class="or-line"></div>
    <span class="primary-font-semibold or-text">{{ 'authentication.or' | translate }}</span>
    <div class="or-line"></div>
  </div>

  <form [formGroup]="signupForm" class="form-container" autocomplete="off"
    (ngSubmit)="handleSignupSubmission().subscribe()" [appMarkFormTouched]="signupForm">
    <app-error-messages [control]="signupForm.controls.email" [errorKeyMapping]="fieldValidationRules().email"
      (ngSubmit)="handleSignupSubmission()">
      <div class="form-group">
        <label class="primary-font-medium form-label" for="email">{{
          'authentication.email' | translate
          }}</label>
        <input type="email" id="email" formControlName="email" class="form-input primary-font-medium"
          appErrorStateHighlight [errorStateControl]="signupForm.controls.email" errStateClass="error-input"
          [placeholder]="'authentication.enter_your_email' | translate" />
      </div>
    </app-error-messages>

    <div class="form-group">
      <label class="primary-font-medium form-label" for="password">{{
        'authentication.password' | translate
        }}</label>
      <div class="password-input-container">
        <app-password-input>
          <input id="password" formControlName="password" class="form-input primary-font-medium" appErrorStateHighlight
            [errorStateControl]="signupForm.controls.password" errorStateClass="error-input"
            [placeholder]="'authentication.enter_password' | translate" />
        </app-password-input>
      </div>
      <!-- Error message -->
      @if (signupForm.controls.password.hasError('serverValidation')) {
      <div class="error-message-container">
        <span class="error-message primary-font-regular invalid-password">
          <svg class="" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <g clip-path="url(#clip0_4_11950)">
              <path
                d="M9 16.4326C12.7279 16.4326 15.75 13.4105 15.75 9.68262C15.75 5.95469 12.7279 2.93262 9 2.93262C5.27208 2.93262 2.25 5.95469 2.25 9.68262C2.25 13.4105 5.27208 16.4326 9 16.4326Z"
                stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 6.68262V9.68262" stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 12.6826H9.0075" stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_4_11950">
                <rect width="18" height="18" fill="white" transform="translate(0 0.682617)" />
              </clipPath>
            </defs>
          </svg>
          {{ getFieldErrorMessage('password') | translate }}
        </span>
      </div>
      } @else if (
      signupForm.controls.password.hasError('pattern') && (!getPasswordValidationStatus().minLength ||
      !getPasswordValidationStatus().hasSpecial ||
      !getPasswordValidationStatus().hasNumber) &&
      (signupForm.controls.password.dirty || signupForm.controls.password.touched)
      ) {
      <div class="error-message-container">
        <span class="error-message primary-font-regular invalid-password">
          <svg class="" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <g clip-path="url(#clip0_4_11951)">
              <path
                d="M9 16.4326C12.7279 16.4326 15.75 13.4105 15.75 9.68262C15.75 5.95469 12.7279 2.93262 9 2.93262C5.27208 2.93262 2.25 5.95469 2.25 9.68262C2.25 13.4105 5.27208 16.4326 9 16.4326Z"
                stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 6.68262V9.68262" stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 12.6826H9.0075" stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_4_11951">
                <rect width="18" height="18" fill="white" transform="translate(0 0.682617)" />
              </clipPath>
            </defs>
          </svg>
          {{ 'authentication.invalid_password_error' | translate }}
        </span>

        <div class="password-requirements-container">
          <ul class="password-requirements">
            @if (!getPasswordValidationStatus().minLength) {
            <li>
              <span class="error-message primary-font-regular">{{
                'authentication.minimum_character_error' | translate
                }}</span>
            </li>
            }
            @if (!getPasswordValidationStatus().hasSpecial) {
            <li>
              <span class="error-message primary-font-regular">{{
                'authentication.one_special_character_error' | translate
                }}</span>
            </li>
            }
          </ul>
          @if (!getPasswordValidationStatus().hasNumber) {
          <ul class="password-requirements">
            <li>
              <span class="error-message primary-font-regular">{{
                'authentication.one_number_error' | translate
                }}</span>
            </li>
          </ul>
          }
        </div>
      </div>
      } @else if (
      signupForm.controls.password.hasError('minlength') &&
      (signupForm.controls.password.dirty || signupForm.controls.password.touched)
      ) {
      <div class="error-message-container">
        <span class="error-message primary-font-regular invalid-password">
          <svg class="" xmlns="http://www.w3.org/2000/svg" width="18" height="19" viewBox="0 0 18 19" fill="none">
            <g clip-path="url(#clip0_4_11952)">
              <path
                d="M9 16.4326C12.7279 16.4326 15.75 13.4105 15.75 9.68262C15.75 5.95469 12.7279 2.93262 9 2.93262C5.27208 2.93262 2.25 5.95469 2.25 9.68262C2.25 13.4105 5.27208 16.4326 9 16.4326Z"
                stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 6.68262V9.68262" stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
              <path d="M9 12.6826H9.0075" stroke="#DA2F2F" stroke-linecap="round" stroke-linejoin="round" />
            </g>
            <defs>
              <clipPath id="clip0_4_11952">
                <rect width="18" height="18" fill="white" transform="translate(0 0.682617)" />
              </clipPath>
            </defs>
          </svg>
          {{ getFieldErrorMessage('password') | translate }}
        </span>
      </div>
      } @else if (
      signupForm.controls.password.hasError('required') &&
      (signupForm.controls.password.dirty || signupForm.controls.password.touched)
      ) {
      <div class="error-message-container">
        <span class="error-message primary-font-regular invalid-password">
          {{ getFieldErrorMessage('password') | translate }}
        </span>
      </div>
      }
    </div>

    @if (isRewardPointsEnabled()) {
    <app-error-messages [control]="signupForm.controls.referrerReferralCode"
      [errorKeyMapping]="fieldValidationRules().referrerReferralCode">
      <div class="form-group">
        <label class="primary-font-medium form-label" for="referral-code">{{ 'authentication.referral_code' | translate
          }} ({{
          'authentication.optional' | translate
          }})</label>
        <input type="text" id="referral-code" formControlName="referrerReferralCode"
          class="form-input primary-font-medium" appErrorStateHighlight errorStateClass="error-input"
          [errorStateControl]="signupForm.controls.referrerReferralCode"
          [placeholder]="'authentication.enter_referral_code' | translate" />
      </div>
    </app-error-messages>
    }

    <p class="primary-font-medium user-agreement-text">
      {{ 'authentication.sign_up_acknowledgement' | translate }}
      <a routerLink="/terms-and-conditions" target="_blank">{{
        'authentication.terms_and_condition' | translate
        }}</a>
      {{ 'authentication.and' | translate }}
      <a routerLink="/privacy-policy" target="_blank">{{
        'authentication.privacy_policy' | translate
        }}</a>
    </p>

    <button type="submit" class="auth-button primary-button custom-button rounded-pill primary-font-medium"
      [disabled]="signupForm.value.email === '' || signupForm.value.password === ''">
      @if (isSubmitting()) {
      <output class="spinner-border spinner-border-sm" aria-hidden="true"></output>
      } @else {
      {{ 'authentication.sign_up_button' | translate }}
      }
    </button>
  </form>
  <p class="primary-font-medium account-prompt">
    {{ 'authentication.already_have_account' | translate }}
    <button (click)="changeToSignInPage.emit()" class="default-button">
      {{ 'authentication.sign_in_button_text' | translate }}
    </button>
  </p>
</div>
